export default {
  生成失败: '生成失败',
  AI总结汇总: 'AI总结汇总'
};
